export default __webpack_public_path__ + "static/media/android-app-icons.e2b07211.webp";